import {ArrowLeftOutlined as AntdArrowLeftOutlined} from '@ant-design/icons';

export default function ArrowLeftOutlined(props) {
  return <AntdArrowLeftOutlined {...props} />;
}
